import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorMessage: {
		id: 'issue-navigator-custom-filters.details-popup.error-state.error-message',
		defaultMessage: "We couldn't display the filter details.",
		description: 'Message displayed to user when the details modal has an error',
	},
});
export default messages;
